<template>
    <div class="modal">
        <div class="modal-content">
            <BaseModalClose @close-modal="setModalOpen(false)" />

            <transition name="fade" mode="out-in">
                <template v-if="isLoading">
                    <BaseLoader class="loader" />
                </template>

                <template v-else>
                    <slot />
                </template>
            </transition>

            <slot name="footer" />
        </div>
    </div>
</template>
<script>

/**
 * External dependencies.
 */
import { mapState, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapState('show/modal', [
            'isLoading',
        ]),
    },

    methods: {
        ...mapMutations('show/modal', [
            'setModalOpen',
        ]),
    },
};
</script>
<style scoped lang="scss">
    @import './Modal.scss';
</style>
